export default "__VITE_PUBLIC_ASSET__c57b7ebb__"